import { render, staticRenderFns } from "./MaterijalEdit.vue?vue&type=template&id=3227d3f9&scoped=true"
import script from "./MaterijalEdit.vue?vue&type=script&lang=js"
export * from "./MaterijalEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterijalEdit.vue?vue&type=style&index=0&id=3227d3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227d3f9",
  null
  
)

export default component.exports